<script setup lang="ts">
/**
 * UI-kit component
 * Category: Footers
 * Name: FooterBottomBar
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=530-16
 *
 * The legal strip under the footer columns: top border on ultraviolet/400, Body/S
 * text in the same color. Desktop/tablet: copyright left, email · address right
 * (legal block wraps onto its own line with an 8px gap when it does not fit).
 * Mobile: centered — copyright + email on the first line, address on the second.
 * "Address:" is a static UI label (not a prop); the legal entity lives inside the
 * address value. CMS guides: copyright ≤25, email ≤40, address ≤60 — nothing
 * truncates, overflow adds lines.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui (dsGap).
 */
// types
import type { FooterBottomBarProps } from '../types/interfaces'

defineOptions({
  name: 'FooterBottomBar',
})

defineProps<FooterBottomBarProps>()
</script>

<template>
  <div class="footer-bottom-bar btly-text-body-s">
    <p class="footer-bottom-bar__copyright">{{ copyright }}</p>
    <span
      class="footer-bottom-bar__dot footer-bottom-bar__dot--mobile"
      aria-hidden="true"
    />
    <div class="footer-bottom-bar__legal">
      <span class="footer-bottom-bar__email">{{ email }}</span>
      <span
        class="footer-bottom-bar__dot footer-bottom-bar__dot--desktop"
        aria-hidden="true"
      />
      <p class="footer-bottom-bar__address">
        <span class="footer-bottom-bar__address-label">Address:</span>
        <span>{{ address }}</span>
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_footer-bottom-bar.scss" />
